module.exports = __webpack_public_path__ + "img/mindfull_bannerr.3cc2f1a0.png";